import React, {useState} from "react";
import Modal from 'react-awesome-modal'
import './image-popup.styles.css'

export const ImagePopup = (props) => {
    const [visible, setVisible] = useState(props.visible);
    const [image, setImage] = useState();
    window.setImageWindow = (stateObject, imageObject, secondImage=null, second=false) => {
        setVisible (stateObject);
        second? setImage(secondImage):setImage(imageObject);
      }
      window.imageVisible = () => {
        return visible;
      }
    return (
        <div className="modal-container"> 
        <Modal visible={visible} effect="fadeInUp" onClickAway={() => setVisible(false)}>
            <div className="image-popup-container">
            <img className="popup-close" onClick={()=>setVisible(false)} src={require("../../imgs/close.png")} alt="logo" loading="lazy"></img>
                <img src={image} alt="pic-popup"></img>
            </div>
        </Modal>
        </div>
    )
}